import { render, staticRenderFns } from "./Orphaned.vue?vue&type=template&id=89ce6e66&"
import script from "./Orphaned.vue?vue&type=script&lang=js&"
export * from "./Orphaned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports